// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#get-residents-for-cooperation-system[data-v-74b4a309]{max-width:1280px;margin-left:auto;margin-right:auto}#get-residents-for-cooperation-system .use-system-title[data-v-74b4a309]{font-weight:700;font-size:18px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
